export const keywordFileUploadJsonSchema = {
  type: "object",
  properties: {
    keywordFileData: {
      type: "array",
      items: { type: "object" },
      title: "",
      minItems: 1,
    },
  },
  required: ["keywordFileData"],
};

export const keywordFileUploadUISchema = {
  type: "VerticalLayout",
  elements: [
    {
      type: "Control",
      scope: "#/properties/keywordFileData",
      component: "partnerFileUpload",
      accept: ".csv",
      isPartnerRequired: false,
      description: "Select a comma-separated CSV file",
    },
  ],
};
